module.exports = __webpack_public_path__ + "img/services-code-icon.e122d4c1.svg";